/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React from "react";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Loader2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";

export default function ApiDataTable({
  selected,
  setSelected,
  hospitalData,
  ishospitalFetching,
}) {
  const [filterValue, setFilterValue] = React.useState("");

  const filteredData = React.useMemo(() => {
    if (!hospitalData || !filterValue) return hospitalData;
    return hospitalData.filter((hospital) =>
      hospital.name.toLowerCase().includes(filterValue.toLowerCase()),
    );
  }, [hospitalData, filterValue]);

  return (
    <div>
      <div className="flex items-center justify-center py-4">
        <Input
          placeholder="Filter api name..."
          value={filterValue}
          onChange={(event) => setFilterValue(event.target.value)}
          className="max-w-sm"
        />
      </div>

      <div className="rounded-md border overflow-auto h-[83vh]">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[150px]">Name</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Space Allocated</TableHead>
              <TableHead>Allowed Users</TableHead>
              <TableHead>API Enabled</TableHead>
              <TableHead>Allowed Tokens</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {ishospitalFetching ? (
              <TableRow>
                <TableCell colSpan={6} className="h-24 text-center">
                  <div className="flex justify-center items-center">
                    <Loader2 className="animate-spin" />
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              filteredData?.map((hospital) => (
                <TableRow
                  onClick={() => setSelected(hospital)}
                  key={hospital.name}
                >
                  <TableCell>{hospital.name}</TableCell>
                  <TableCell className="font-medium">{hospital.type}</TableCell>
                  <TableCell>
                    {hospital.space_allocated === null
                      ? "Unlimited"
                      : `${hospital.space_allocated} GB`}
                  </TableCell>
                  <TableCell>{hospital.allowed_users}</TableCell>
                  <TableCell>
                    {hospital.api?.api_access === true ? (
                      <Badge className="text-center">Yes</Badge>
                    ) : (
                      <Badge variant="destructive" className=" text-center">
                        No
                      </Badge>
                    )}
                  </TableCell>
                  <TableCell>
                    {hospital.api?.allowed_requests
                      ? hospital.api?.allowed_requests
                      : "-"}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
